<template>
    <div ref="modal" class="modal fade">
        <div class="modal-dialog" :class="modalType">
            <div class="modal-content">
                <div class="modal-header">
                    <button v-if="!ok" type="button" class="close" data-dismiss="modal" aria-hidden="true">
                        &times;
                    </button>
                    <h4 class="modal-title">
                        {{ title }}
                    </h4>
                </div>
                <slot name="outer" />
                <ValidateForm ref="form" :form-type="formType" :form-no-validate="formNoValidate" :validator="validator">
                    <div class="modal-body">
                        <slot />
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button v-if="!ok" type="button" class="btn btn-default" data-dismiss="modal">
                                Annulla
                            </button>
                            <button type="submit" class="btn btn-primary">
                                Ok
                            </button>
                        </slot>
                    </div>
                </ValidateForm>
            </div>
        </div>
    </div>
</template>

<script>
'use strict';

/* eslint-disable vue/require-default-prop */
import ValidateForm from './validate-form.vue';

export default {
    components: {
        ValidateForm,
    },
    props: {
        //modal-lg, modal-xxl
        modalType: String,
        ok: Boolean,
        static: Boolean,
        formType: String,
        formNoValidate: [Boolean, String],
        title: String,
        validator: Object,
    },
    data() {
        return {
            form: undefined,
        };
    },
    mounted() {
        Object.defineProperty(this, 'form', { value: this.$refs.form, writable: false });
    },
    methods: {
        resetValidator() {
            this.form.resetValidator();
        },
        resetValidatorAndForm() {
            this.form.resetValidator();
        },
        validateForm() {
            return this.form.validateForm();
        },
        show(submitCallabck) {
            const modal = $(this.$refs.modal);
            const show = { show: true };
            if(this.static) {
                show.backdrop = 'static';
                show.keyboard = false;
            }
            modal.modal(show);
            this.form.$on('form.submit', () => {
                if(submitCallabck)
                    submitCallabck();
                else
                    this.hide();
            });
            modal.off('hidden.bs.modal.1').one('hidden.bs.modal.1', () => {
                this.form.$off('form.submit');
            });
        },
        hide() {
            return new Promise((resolve) => {
                const modal = $(this.$refs.modal);
                modal.off('hidden.bs.modal.2').one('hidden.bs.modal.2', () => {
                    resolve();
                });
                modal.modal('hide');
            });
        },
        loadDialog(obj, options) {
            this.form.loadDialog(obj, options);
        },
        saveDialog(obj, options) {
            return this.form.saveDialog(obj, options);
        },
        submit() {
            this.form.submit();
        },
    },
};
</script>
